import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { StyledSecondaryNavBar, StyledContainer } from '@whitelabel/rentalcover-shared/styled/StyledSecondaryNavBar';
import rentalcoverSharedMessages from '@whitelabel/rentalcover-shared/helpers/messages/commonMsg';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import { getButtonProps } from '@whitelabel/rentalcover-shared/helpers/button';
import { useRCOffers } from '../../../../helpers/hooks';
import { protectionLink, claimsLink, offersLink, profileLink, isPathActive } from '../../../../helpers/navLinks';
import { StyledAccountSecondaryNavBar, StyledNavItem } from './styledSecondaryNavBar';

interface ISecondaryNavBarProps {
  claimReference?: string;
}

const SecondaryNavBar = ({ claimReference }: ISecondaryNavBarProps) => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const { pathname } = useLocation();
  const { showOffers } = useRCOffers();

  // useLocation includes the locale prefix (e.g. /en/claims) but nav link paths don't
  const relativePathname = pathname.replace(new RegExp(`^/${locale}(?=/|$)`), '');

  if (claimReference) {
    return (
      <StyledSecondaryNavBar>
        <StyledContainer>
          <StyledNavItem
            key="details"
            name={formatMessage(rentalcoverSharedMessages.yourClaimsLinkText)}
            icon={IconArrowLeft}
            {...getButtonProps({ link: `/claims/${claimReference}/details`, locale })}
          />
        </StyledContainer>
      </StyledSecondaryNavBar>
    );
  }

  return (
    <StyledAccountSecondaryNavBar>
      <StyledContainer>
        <StyledNavItem
          {...protectionLink(intl)}
          {...getButtonProps({ link: protectionLink(intl).path, locale })}
          $active={isPathActive(relativePathname, protectionLink(intl).path)}
          key="protection"
        />
        <StyledNavItem
          {...claimsLink(intl)}
          {...getButtonProps({ link: claimsLink(intl).path, locale })}
          $active={isPathActive(relativePathname, claimsLink(intl).path)}
          key="claims"
        />
        {showOffers && (
          <StyledNavItem
            {...offersLink(intl)}
            {...getButtonProps({ link: offersLink(intl).path, locale })}
            $active={isPathActive(relativePathname, offersLink(intl).path)}
            key="offers"
          />
        )}
        <StyledNavItem
          {...profileLink(intl)}
          {...getButtonProps({ link: profileLink(intl).path, locale })}
          $active={isPathActive(relativePathname, profileLink(intl).path)}
          key="profile"
        />
      </StyledContainer>
    </StyledAccountSecondaryNavBar>
  );
};

export default SecondaryNavBar;
